<template>
  <div
    class="fixed hidden bottom-0 left-0 z-30 w-full py-3 bg-white border-t border-gp-grey-40 no-print max-lg:block"
  >
    <div class="container max-md:px-3.75 grid h-full max-w-lg grid-cols-3 mx-auto">
      <router-link class="icon-nav text-xss" :to="{ name: 'publicationCategories' }">
        <div class="flex flex-col gap-1 items-center">
          <IconGrid></IconGrid>
          {{ $t('page.categories') }}
        </div>
      </router-link>
      <router-link class="icon-nav text-xss" :to="{ name: 'selectCategory' }">
        <div class="flex flex-col gap-1 items-center">
          <IconAdd></IconAdd>
          {{ $t('nav.addPublication') }}
        </div>
      </router-link>
      <router-link class="icon-nav text-xss relative" :to="{ name: myPublicationsRouteName }">
        <div class="flex flex-col gap-1 items-center">
          <IconBox></IconBox>
          {{ $t('nav.myPublications') }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAppStore } from '@/store';

import IconGrid from '@icons/IconGrid.vue';
import IconBox from '@icons/IconBox.vue';
import IconAdd from '@icons/IconAdd.vue';

const store = useAppStore();

const myPublicationsRouteName = computed(() => {
  return store.userData?.has_business_account ? 'myBusinessPublications' : 'myPublications';
});
</script>

<style scoped>
.router-link-exact-active {
  color: #409dba;
}
</style>
